import { BasePaper } from './BasePaper';

export class EmptyPaper implements BasePaper {
  public paper;
  getText(): string {
    return 'EmptyPaper-getText()';
  }
}
